import { Form, Input, message, Modal } from "antd";
import React, { useEffect, useState } from "react";

type Props = {
  isEdit: boolean;
  open: boolean;
  id: number;
  name: string;
  onConfirm: (params: { name: string; id?: number }) => void;
  onCancel: () => void;
};

export default function EditFolderModal(props: Props) {
  const { isEdit, open, id, name, onConfirm, onCancel } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name,
      });
    }
  }, []);

  const confirm = () => {
    form
      .validateFields()
      .then((values) => {
        if (!isEdit) {
          onConfirm(values);
        } else {
          onConfirm({ ...values, id });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Modal
      open={open}
      title={isEdit ? "编辑" : "新建"}
      onOk={confirm}
      onCancel={onCancel}
    >
      <Form form={form}>
        <Form.Item
          label="名称"
          name="name"
          rules={[{ required: true, message: "请输入文件夹名称" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export const useFolderEdit = (): [
  {
    visible: boolean;
    isEdit: boolean;
    id: number;
    name: string;
  },
  {
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
    setId: React.Dispatch<React.SetStateAction<number>>;
    setName: React.Dispatch<React.SetStateAction<string>>;
  }
] => {
  const [visible, setVisible] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [id, setId] = useState<number>(0);
  const [name, setName] = useState<string>("");
  return [
    {
      visible,
      isEdit,
      id,
      name,
    },
    {
      setVisible,
      setIsEdit,
      setId,
      setName,
    },
  ];
};
